import { useQuery } from "@tanstack/react-query";
import { foundationMembersService } from "@/services/foundationMembersService";

export const foundationMembersQueryKeys = {
  all: ["foundation-members"],
  applications: (params) => [
    ...foundationMembersQueryKeys.all,
    "applications",
    params,
  ],
};

export const useFoundationMemberApplications = (params = {}, options = {}) => {
  return useQuery({
    queryKey: foundationMembersQueryKeys.applications(params),
    queryFn: () => foundationMembersService.getApplications(params),
    staleTime: 0,
    ...options,
  });
};
